import React from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageNameProps {
  language?: string;
}

export const LanguageName: React.FC<LanguageNameProps> = (props) => {
  const __ = useTranslation().t;
  switch (props.language) {
    case 'pt-BR':
      return __('portuguese');
    case 'es':
      return __('spanish');
    case 'en':
    default:
      return __('english');
  }
};
